/**
 * Edits the current URL's query params in place via `history.replaceState`,
 * so there is no navigation or new history entry. Skips the write when the
 * URL is unchanged.
 */
export function replaceUrlParams(
  mutate: (params: URLSearchParams) => void,
): void {
  if (typeof window === "undefined") return;
  const url = new URL(window.location.href);
  mutate(url.searchParams);
  if (url.href !== window.location.href) {
    window.history.replaceState({}, "", url.toString());
  }
}
